import { render, staticRenderFns } from "./activeChatAlerts.vue?vue&type=template&id=ba3db410&"
import script from "./activeChatAlerts.vue?vue&type=script&lang=js&"
export * from "./activeChatAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports